import { render, staticRenderFns } from "./block-notifications-list-item.vue?vue&type=template&id=240829dd&scoped=true&lang=pug&"
import script from "./block-notifications-list-item.vue?vue&type=script&lang=js&"
export * from "./block-notifications-list-item.vue?vue&type=script&lang=js&"
import style0 from "./block-notifications-list-item.vue?vue&type=style&index=0&id=240829dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240829dd",
  null
  
)

export default component.exports